<template>
  <span class="has-text-weight-bold">{{ currentCountDown }}</span>
</template>

<script>
import VueTypes from 'vue-types';
import moment from 'moment';
import _ from 'lodash';

export default {
  name: 'LsCountdownTimer',
  props: {
    onCountdownEnd: VueTypes.func.isRequired,
    expiresAt: VueTypes.string.isRequired,
  },
  data() {
    return {
      currentCountDown: null,
      interval: null,
    };
  },
  created() {
    // call this.countDown once to avoid delay in displaying numbers
    this.countDown();
    this.interval = setInterval(this.countDown, 1000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    countDown() {
      const timeDiff = moment(this.expiresAt).diff(moment.utc().format('YYYY-MM-DD HH:mm:ss'));
      const duration = moment.duration(timeDiff);
      const { days, hours, minutes, seconds } = duration._data;

      const dayString = `${days ? this.addLeadingZero(days) + ' : ' : ''}`;
      const hourString = `${this.addLeadingZero(hours)}`;
      const minuteString = `${this.addLeadingZero(minutes)}`;
      const secondString = `${this.addLeadingZero(seconds)}`;

      this.currentCountDown = `${dayString}${hourString} : ${minuteString} : ${secondString}`;

      if (duration <= 0) {
        this.onCountdownEnd();
        clearInterval(this.interval);
      }
    },
    addLeadingZero(num) {
      return num < 10 ? `0${_.toString(num)}` : num;
    },
  },
};
</script>
